// extracted by mini-css-extract-plugin
module.exports = {"container":"HouseBinds_container__1MmlV","row":"HouseBinds_row__3GIgW"};